import type { ProductPromotion } from "@itaas/pep-contracts";

export function isPromotionActive(promo: ProductPromotion | undefined | null): boolean {
  if (!promo?.active || !promo.discountPercent || promo.discountPercent <= 0) return false;
  if (promo.validUntil) {
    const end = new Date(promo.validUntil);
    if (!Number.isNaN(end.getTime()) && end.getTime() < Date.now()) return false;
  }
  return true;
}

export function promotionAppliesToEdition(promo: ProductPromotion, edition: string): boolean {
  if (!promo.appliesToEditions?.length) return true;
  return promo.appliesToEditions.includes(edition);
}

export function discountedAmount(base: number, discountPercent: number): number {
  return base * (1 - discountPercent / 100);
}

export function promoBadgeLabel(promo: ProductPromotion, locale: "fr" | "en" = "fr"): string {
  if (locale === "en" && promo.badgeEn) return promo.badgeEn;
  if (promo.badgeFr) return promo.badgeFr;
  return locale === "en" ? `-${promo.discountPercent}%` : `−${promo.discountPercent} %`;
}

export function promoLabel(promo: ProductPromotion, locale: "fr" | "en" = "fr"): string | null {
  if (locale === "en" && promo.labelEn) return promo.labelEn;
  if (promo.labelFr) return promo.labelFr;
  return null;
}

export function resolveActivePromotion(
  promo: ProductPromotion | undefined | null,
  edition: string,
): ProductPromotion | null {
  if (!promo || !isPromotionActive(promo) || !promotionAppliesToEdition(promo, edition)) {
    return null;
  }
  return promo;
}
